import auth, {setToken, setUser} from './auth'
import cameras from './cameras'
import gateways from './gateways'
import search from './search'
import settings, {saveTenant} from './settings'
import sites from './sites'
import stops from './stops'
import targets from './targets'
import temperatures from './temperatures'
import tenants from './tenants'
import users from './users'
import {combineReducers, configureStore} from '@reduxjs/toolkit'
import {authApi} from '@services/auth'
import {camerasApi} from '@services/cameras'
import {gatewaysApi} from '@services/gateways'
import {searchApi} from '@services/search'
import {sitesApi} from '@services/sites'
import {stopsApi} from '@services/stops'
import {targetsApi} from '@services/targets'
import {temperaturesApi} from '@services/temperatures'
import {tenantsApi} from '@services/tenants'
import {usersApi} from '@services/users'
import {isSysAdmin} from 'helpers/role'

const combinedReducer = combineReducers({
  auth,
  users,
  tenants,
  sites,
  cameras,
  stops,
  targets,
  search,
  gateways,
  temperatures,
  settings,
  [authApi.reducerPath]: authApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [tenantsApi.reducerPath]: tenantsApi.reducer,
  [sitesApi.reducerPath]: sitesApi.reducer,
  [camerasApi.reducerPath]: camerasApi.reducer,
  [stopsApi.reducerPath]: stopsApi.reducer,
  [targetsApi.reducerPath]: targetsApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [gatewaysApi.reducerPath]: gatewaysApi.reducer,
  [temperaturesApi.reducerPath]: temperaturesApi.reducer
})

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined
    localStorage.removeItem('token')
  }
  return combinedReducer(state, action)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(authApi.middleware)
      .concat(usersApi.middleware)
      .concat(tenantsApi.middleware)
      .concat(sitesApi.middleware)
      .concat(camerasApi.middleware)
      .concat(stopsApi.middleware)
      .concat(targetsApi.middleware)
      .concat(searchApi.middleware)
      .concat(gatewaysApi.middleware)
      .concat(temperaturesApi.middleware)
})

export const beginUserSession = (token, user) => async dispatch => {
  dispatch(setToken({token}))
  dispatch(setUser({user}))

  // Check for persisted tenant selection first
  const persistedTenant = (() => {
    try {
      const stored = localStorage.getItem('selectedTenant')
      return stored ? JSON.parse(stored) : null
    } catch (error) {
      console.error('Error loading persisted tenant:', error)
      return null
    }
  })()

  console.log('beginUserSession - persistedTenant:', persistedTenant)
  console.log('beginUserSession - user:', user)

  // Use persisted tenant if available and user has access to it
  let tenant = null
  if (persistedTenant && user?.tenants) {
    // Check if user still has access to the persisted tenant
    const hasAccess = user.tenants.some(t => t.id === persistedTenant.id)
    console.log('beginUserSession - hasAccess to persisted tenant:', hasAccess)
    if (hasAccess) {
      tenant = persistedTenant
    }
  }

  // Fall back to user's default tenant if no persisted tenant or access lost
  if (!tenant) {
    tenant =
      !user || Object.keys(user).length === 0 || isSysAdmin(user)
        ? null
        : user.tenants?.filter(item => item.id === user.tid)[0] || {id: user.tid}
  }

  console.log('beginUserSession - final tenant to set:', tenant)

  // Only dispatch saveTenant if we have a tenant to set
  // This prevents clearing localStorage when we don't want to
  if (tenant) {
    dispatch(saveTenant(tenant))
  }
}

export default store
